enum BraintreeTokenizedCardTypeEnum {
    AMEX = "American Express",
    DISCOVER = "Discover",
    MASTERCARD = "MasterCard",
    VISA = "Visa",
}

export default BraintreeTokenizedCardTypeEnum;
